import styled from "styled-components";
import { BaseModalContainer, BaseSubModalContainer } from "../modals.styled";

export const ModalContainer = styled(BaseModalContainer)`
    width: 40vw;
    height: 70vh;

    @media (max-width: 768px) {
        height: 70vh;
        width: 95vw;
    }
`;

export const FormContainer = styled(BaseSubModalContainer)`
    gap: 1rem;
    & > * {
        &:first-child {
            flex: 1;
        }
        &:last-child {
            height: 4rem;
        }
    }
`;

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    user-select: none;

    padding: 0 1rem;

    margin-bottom: 2rem;

    min-height: 3rem;
    border-radius: 0.2rem;

    background: white;
    color: ${(props) => props.theme.colors.primary[200]};

    cursor: pointer;

    font-size: 0.9rem;
    font-weight: ${(props) => props.theme.fontWeight.bold};

    &:hover {
        background-color: ${(props) => props.theme.colors.primary[50] + "44"};
    }
`;

export const Container = styled.div`
    display: flex;
    flex-flow: column;
    overflow: auto;
`;

export const StyledImage = styled.img`
    width: 8rem;
    height: 8rem;
    max-width: 8rem;
    max-height: 8rem;
    object-fit: cover;
`;
